// eslint-disable-next-line no-restricted-imports
import { useDirectoryGetSchemasQuery } from 'api/generated/graphql';
import { parseDirectorySchemaData, useError } from 'api/helpers';
import { DirectorySchemaData } from 'api/types/data';
import { lodash } from 'helpers';

export const useDirectoryGetSchemas = () => {
  const { loading, error: apolloError, data } = useDirectoryGetSchemasQuery();

  const error = useError(apolloError);

  const schemas: DirectorySchemaData[] | null | undefined =
    data?.directorySchemas
      ? lodash.compact(data?.directorySchemas).map(parseDirectorySchemaData)
      : undefined;

  return { loading, error, schemas };
};
